import { SiteListState } from "./SiteList-State";

export default function siteListReducer(state = SiteListState, action) {
  let { data } = JSON.parse(JSON.stringify(state));
  let { name, value, server_id } = action;

  switch (action.type) {
    case "TOGGLE-SITE-LIST-FILTER":
      if (name === `sort_by`) {
        if (data.params.sort_by === value) {
          data.params.sort_order =
            data.params.sort_order === `desc` ? `asc` : `desc`;
        }
      }
      if (name === "limit") {
        data.params.page = 1;
      }
      data.params[name] = value;

      return { ...state, data };

    case "ON-SITE-SERVER-CHANGE":
      data.params.server_id = server_id;
      // if (server_id) {
      data.params.page = "";
      // }
      return { ...state, data };

    case "ON-SITE-RESET":
      data.params.server_id = ``;
      return { ...state, data };

    case "SET-DEFAULT-SEARCH":
      data.params.q = ``;
      data.params.server_id = ``;
      data.params.page = 1;
      data.payload.initialLoading = true;
      return { ...state, data };

    default:
      return state;
  }
}
